import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { useT } from "@/i18n/LanguageContext";

const WHATSAPP_LINK =
  "https://wa.me/34647931239?text=Hello%20Coumba%20Kandji%20Diamonds%2C%20I%27d%20like%20to%20enquire%20about...";

export const WhatsAppButton = () => {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setMounted(true);
      setOpen(true);
    }, 1800);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div
      data-testid="whatsapp-floating"
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-[60] flex items-end gap-3"
    >
      {/* Tooltip / popup */}
      {open && mounted && (
        <div className="relative max-w-[240px] backdrop-blur-xl bg-white/95 border border-ink/10 shadow-soft-lift px-5 py-4 pr-9 animate-fade-up">
          <button
            aria-label={t("whatsapp.close")}
            onClick={() => setOpen(false)}
            className="absolute top-2 right-2 text-muted_text hover:text-ink transition-colors"
          >
            <X className="w-3.5 h-3.5" strokeWidth={1.4} />
          </button>
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold mb-1">
            {t("whatsapp.label")}
          </div>
          <p className="font-display text-[15px] leading-snug text-ink">
            {t("whatsapp.question")}
          </p>
          {/* Pointer arrow */}
          <div className="absolute -bottom-2 right-7 w-3 h-3 bg-white/95 border-r border-b border-ink/10 rotate-45" />
        </div>
      )}

      {/* Floating WhatsApp button */}
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noreferrer"
        aria-label={t("whatsapp.aria")}
        onMouseEnter={() => setOpen(true)}
        className="relative group flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-soft-lift hover:scale-105 transition-transform duration-300"
      >
        <span
          aria-hidden
          className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping-slow"
          style={{
            animation: "ckPing 2.4s cubic-bezier(0,0,0.2,1) infinite",
          }}
        />
        <MessageCircle
          className="w-7 h-7 md:w-8 md:h-8 relative z-10"
          strokeWidth={1.6}
        />
      </a>

      <style>{`
        @keyframes ckPing {
          0%   { transform: scale(1);    opacity: 0.55; }
          75%, 100% { transform: scale(1.6); opacity: 0; }
        }
      `}</style>
    </div>
  );
};
